export function installAccessibilityGuards() {
  const app = document.getElementById('app');
  if (!app) return;

  const setInert = (on) => {
    if (on) {
      if (!app.hasAttribute('inert')) app.setAttribute('inert', '');
      const active = document.activeElement;
      if (active && app.contains(active)) {
        try { active.blur(); } catch (_) { void 0; }
      }
      const focusTarget = document.querySelector(
        '.v-overlay__content,[role="dialog"],.modal,.modal-content'
      );
      if (focusTarget) {
        if (!focusTarget.hasAttribute('tabindex')) {
          try { focusTarget.setAttribute('tabindex', '-1'); } catch (_) { void 0; }
        }
        try { focusTarget.focus(); } catch (_) { void 0; }
      }
    } else {
      if (app.hasAttribute('inert')) app.removeAttribute('inert');
    }
  };

  setInert(app.getAttribute('aria-hidden') === 'true');

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
        setInert(app.getAttribute('aria-hidden') === 'true');
      }
    }
  });
  observer.observe(app, { attributes: true, attributeFilter: ['aria-hidden'] });
}